import i18n, { ReadCallback } from 'i18next';

import { initReactI18next } from 'react-i18next';
import { withSentryHub } from './sentryService';

export type Locale =
  | 'bg_BG'
  | 'cs_CZ'
  | 'da_DK'
  | 'de_AT'
  | 'de_CH'
  | 'de_DE'
  | 'el_GR'
  | 'en_GB'
  | 'en_IE'
  | 'es_ES'
  | 'default'
  | 'fi_FI'
  | 'fr_BE'
  | 'fr_CH'
  | 'fr_FR'
  | 'hr_HR'
  | 'hu_HU'
  | 'it_IT'
  | 'nl_NL'
  | 'pl_PL'
  | 'pt_PT'
  | 'ro_RO'
  | 'ru_RU'
  | 'sk_SK'
  | 'sl_SI'
  | 'sv_SE'
  | 'tr_TR';

export type Realm = 'zooplus' | 'bitiba';

export const fallbackLng = {
  bg_BG: ['en_GB'],
  cs_CZ: ['en_GB'],
  da_DK: ['en_GB'],
  de_AT: ['de_DE'],
  de_CH: ['de_DE'],
  de_DE: ['en_GB'],
  default: ['en_GB'],
  el_GR: ['en_GB'],
  en_IE: ['en_GB'],
  es_ES: ['en_GB'],
  fi_FI: ['en_GB'],
  fr_BE: ['fr_FR'],
  fr_CH: ['fr_FR'],
  fr_FR: ['en_GB'],
  hr_HR: ['en_GB'],
  hu_HU: ['en_GB'],
  it_IT: ['en_GB'],
  nl_NL: ['en_GB'],
  pl_PL: ['en_GB'],
  pt_PT: ['en_GB'],
  ro_RO: ['en_GB'],
  ru_RU: ['en_GB'],
  sk_SK: ['en_GB'],
  sl_SI: ['en_GB'],
  sv_SE: ['en_GB'],
  tr_TR: ['en_GB'],
};

export const initializeI18n = (realm: Realm, locale: Locale) => {
  i18n
    .use(initReactI18next)
    .use({
      type: 'backend',
      read: (language: string, namespace: string, callback: ReadCallback) => {
        import(
          `../locales/${realm}/${
            namespace && 'translation' !== namespace ? `${namespace}/` : ''
          }${language.replace('-', '_')}.json`
        )
          .then((data) => {
            console.log(
              'Loaded translations ns= ',
              namespace,
              ', lng= ',
              language,
              ', data= ',
              data,
            );
            callback(null, data.default);
          })
          .catch((error) => {
            console.error(error);
            callback(error, false);
            withSentryHub().captureException(error);
          });
      },
    })
    .init({
      lng: locale,
      ns: [],
      fallbackLng,
      debug: false, // set this to true to see your requests beeing logged
    });
  return i18n;
};
